import { SettingsActions, Action } from 'common/types';
import { setDocWithCreatedBy, getCurrentUserData } from 'firebase/utils';
import { db } from 'firebase/config';
import { collection, doc, getDoc, setDoc, query, where, getDocs } from 'firebase/firestore';
const settingsCollection = collection(db, 'settings');
export const createSettingsActions: Action<SettingsActions> = (state, updateState) => ({
    update: (settings) => {
        // Solo actualiza el estado local sin guardar en Firestore
        updateState({ settings: { ...state.settings, ...settings } })
    },
    saveSettings: async () => {
        try {
            // Obtener los datos del usuario actual
            const userData = await getCurrentUserData();
            if (!userData || !userData.uid) {
                throw new Error('Usuario no autenticado');
            }

            // Verificar si ya existe un documento de configuraciones
            const q = query(
                settingsCollection,
                where('parentUserId', '==', userData.parentId || userData.uid)
            );
            const querySnapshot = await getDocs(q);

            if (!querySnapshot.empty) {
                // Si existe un documento, obtener su ID y actualizarlo
                const existingSettingsDoc = querySnapshot.docs[0];


                // Usar setDoc directamente para actualizar el documento existente
                await setDoc(doc(settingsCollection, existingSettingsDoc.id), {
                    ...state.settings,
                    id: existingSettingsDoc.id,
                    ownerId: userData.uid,
                    parentUserId: userData.parentId || userData.uid,
                    updatedAt: new Date().toISOString()
                });
                console.log('Configuraciones actualizadas correctamente');
            } else {
                // Crear un nuevo documento
                await setDocWithCreatedBy(settingsCollection, state.settings);
                console.log('Configuraciones creadas correctamente');
            }

            return state.settings;
        } catch (error) {
            console.error('Error al guardar configuraciones:', error);
            throw error;
        }
    }
});
